import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `currentColor` : `var(--color-${color})`;
};
const SvgTiktokColorIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}

    <g clipPath="url(#clip0_11_41)">
      <path fill={getFillColor(props.color) === "currentColor" ? `var(--color-tiktok-logo-black)` : getFillColor(props.color)}
          d="M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0Z"/>
      <g>
        <path fill={getFillColor(props.color) === "currentColor" ? `var(--color-tiktok-logo-blue)` : getFillColor(props.color)}
            d="M13.8762 13.7122V12.8436C13.5854 12.804 13.2899 12.7793 12.9884 12.7793C9.35549 12.7793 6.40002 15.7348 6.40002 19.3677C6.40002 21.5967 7.51368 23.5692 9.21266 24.762C8.11613 23.5848 7.4653 22.0079 7.4653 20.2759C7.4653 16.6953 10.3151 13.7954 13.8762 13.7122Z"/>
        <path fill={getFillColor(props.color) === "currentColor" ? `var(--color-tiktok-logo-blue)` : getFillColor(props.color)}
            d="M14.0317 23.3035C15.6526 23.3035 16.9937 21.9956 17.0539 20.3891L17.0675 6.06448L19.6653 6.06544L19.6613 6.04389C19.6067 5.74917 19.5768 5.44592 19.5768 5.13563H15.9973L15.9915 19.4809C15.9313 21.0873 14.6092 22.3766 12.9884 22.3766C12.4847 22.3766 12.0103 22.2507 11.5927 22.0309C12.1395 22.7888 13.0279 23.3035 14.0317 23.3035Z"/>
        <path fill={getFillColor(props.color) === "currentColor" ? `var(--color-tiktok-logo-blue)` : getFillColor(props.color)}
            d="M24.5566 10.9558V10.1154C23.5569 10.1154 22.6257 9.81821 21.8447 9.30904C22.54 10.1077 23.4846 10.7263 24.5566 10.9558Z"/>
        <path fill={getFillColor(props.color) === "currentColor" ? `var(--color-tiktok-logo-pink)` : getFillColor(props.color)}
            d="M21.8447 9.30908C21.0829 8.43415 20.62 7.29239 20.62 6.04396H19.6448C19.8973 7.4078 20.7232 8.57783 21.8447 9.30908Z"/>
        <path fill={getFillColor(props.color) === "currentColor" ? `var(--color-tiktok-logo-pink)` : getFillColor(props.color)}
            d="M12.9884 16.3315C11.3293 16.3315 9.95953 17.7085 9.95953 19.3677C9.95953 20.523 10.6349 21.5269 11.5927 22.0309C11.2357 21.5363 11.0228 20.9312 11.0228 20.276C11.0228 18.6169 12.3727 17.267 14.0317 17.267C14.3415 17.267 14.6386 17.3181 14.9196 17.4061V13.7519C14.6288 13.7124 14.3333 13.6876 14.0317 13.6876C13.9796 13.6876 13.9281 13.6903 13.8762 13.6915L13.8624 13.6922L13.8527 16.4583C13.5717 16.3703 13.2981 16.3315 12.9884 16.3315Z"/>
        <path fill={getFillColor(props.color) === "currentColor" ? `var(--color-tiktok-logo-pink)` : getFillColor(props.color)}
            d="M24.5566 10.9129L24.54 10.9097L24.5392 13.6735C22.6832 13.6735 20.9586 13.0626 19.5547 12.0549L19.5558 19.3677C19.5558 23.0006 16.6212 25.9378 12.9884 25.9378C11.5845 25.9378 10.2828 25.5133 9.21265 24.762C10.4163 26.0541 12.1308 26.8644 14.0317 26.8644C17.6646 26.8644 20.6201 23.9089 20.6201 20.276V13.0018C22.024 14.0094 23.744 14.6032 25.6 14.6032V11.0237C25.2422 11.0237 24.8933 10.985 24.5566 10.9129Z"/>
        <path fill={getFillColor(props.color) === "currentColor" ? `var(--color-tiktok-logo-white)` : getFillColor(props.color)}
            d="M19.5768 19.3677V12.0934C20.9806 13.1011 22.7006 13.6949 24.5566 13.6949V10.9129C23.4846 10.6834 22.5401 10.1077 21.8448 9.30901C20.7232 8.57776 19.9138 7.40774 19.6613 6.0439H17.0406L17.0349 20.3891C16.9747 21.9956 15.6526 23.2849 14.0317 23.2849C13.0278 23.2849 12.1395 22.7888 11.5926 22.0309C10.6349 21.5268 9.97947 20.523 9.97947 19.3677C9.97947 17.7085 11.3293 16.3587 12.9884 16.3587C13.2981 16.3587 13.5952 16.4098 13.8762 16.4978V13.6915C10.3152 13.7747 7.44342 16.6953 7.44342 20.2759C7.44342 22.0079 8.11611 23.5848 9.21265 24.762C10.2828 25.5132 11.5845 25.9561 12.9884 25.9561C16.6212 25.9561 19.5768 23.0006 19.5768 19.3677Z"/>
      </g>
    </g>
  </svg>
);

export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}

const SvgTiktokColorStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgTiktokColorIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const TiktokColorIcon: any = SvgTiktokColorStyle;
export default TiktokColorIcon;
